import { css } from 'styled-components';

export default css`
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
`;
